<template>
  <div class="summary-table">
    <el-table
      :data="tableData" 
      style="width: 100%"
      row-key="id"
      size="medium"
      border
      headerCellClassName="table-hadder"
      cellClassName="unit-set-cell"
      :tree-props="{children: 'children'}">
      <el-table-column
        prop="name"
        align="left"
        label="指标"
        className="first-row"
       >
        <template slot="header">
          <div class="flex items-center">
            <span style="margin-right:2px">指标</span>
            <el-tooltip class="item" effect="light" content="当前表格统计到次末级指标下的数据配置情况" placement="top">
            <i class="text-sm iconfont icon-shuoming text-theme-black-350 cursor-pointer"></i>
          </el-tooltip>
          </div>
      </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="配置进度"
       >
        <template slot-scope="scope">
          <span class="finished" v-if="scope.row.finishCount==scope.row.colCount">已完成</span>
          <span class="no-finished" v-else>{{scope.row.finishCount}}/{{scope.row.colCount}}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {getOverViewTable} from '@/api/index-statistics'
export default {
  
  name: 'OverviewTable',
  data() {
    return {
      tableData: [],
    }
  },
  props: {
    reportValue: Number,
  },
  watch:{
    // reportValue(){
    //   this.getTableData()
    // }
  
  },
  mounted(){
    this.getTableData()
  },
  methods: {
    getTableData(){
      getOverViewTable({indicatorStatisticsId:this.reportValue}).then(res=>{
        console.log(res)
        this.tableData=res.data.data
      })

    }


  }
}
</script>

<style lang="scss" scoped>
.summary-table{
  ::v-deep .unit-set-cell{
    font-size: 14px;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.85);
  }
  ::v-deep .table-hadder,::v-deep .first-row{
    background-color: #F5F5F5;
  }
}

.finished{
  color: rgba(0, 0, 0, 0.45);

}
.no-finished{
  color:#E34152;

}


</style>